import React, { useState } from "react";

export const BtnXoa = ({ item, onDelete}) => {
    return (
            <a href="#!" type="button" className="popover-basic"  onClick={() => onDelete(item)} title="Xóa">
                <img src="/app-assets/images/icon-xoa-v2.png" alt="Xóa" />
            </a>
    );
};